import axios from 'axios'
import { config } from '../config'
import { session } from './session'

export const http = axios.create({ baseURL: config.baseURL })

http.interceptors.request.use((request) => {
	const token = session.get()

	if (token) {
		request.headers = {
			...request.headers,
			[config.backendTokenKEY]: `Bearer ${token}`,
		}
	}

	return request
})

// http.interceptors.response.use(
// 	(response) => {
// 		return response
// 	},
// 	(error) => {
// 		const token = session.get()
// 		if (error.response && error.response.status === 401 && token) {
// 			// Redirect to the login page
// 			window.location.pathname = '/auth'
// 		}
// 		return Promise.reject(error)
// 	},
// )
